<template>
  <div class="wap-model-container">
    <div v-if="title" class="model-title">
      <span class="title">{{ title }}</span>
      <div class="right-wrapper">
        <slot name="titleRight"></slot>
      </div>
    </div>
    <div class="model-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModelContainer",
  mixins: [],
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  model: {},
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="less" scoped>
.wap-model-container {
  background: #fff;
  margin: 4px 0;
  border-radius: 0;
  background: #fff;

  .model-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px 0 16px;

    .title {
      line-height: 28px;
      font-size: 16px;
      font-weight: bold;
    }
  }

  .model-content {
    padding: 24px;
    background-color: #f8f9f9;
  }
}
</style>
